import { TFunction } from "@outschool/localization";
import { gql } from "@outschool/ui-apollo";

import {
  ParentScheduleCalendar_EnrollmentFragment,
  ParentScheduleQueryQuery,
  TeacherScheduleQueryQuery,
} from "../../shared/generated/graphql";

export type ParentCalendarUser = NonNullable<
  ParentScheduleQueryQuery["currentUser"]
>;
export type TeacherCalendarUser = NonNullable<
  TeacherScheduleQueryQuery["currentUser"]
>;

// Meeting.groupIntoMeetingListings makes "fake meetings" which have a `key` instead of a `uid`, for flex classes
// ref. callsite in ParentScheduleCalendar where enrollments are mapped to `CalendarMeeting`s, and PR #5412
export type CalendarMeeting = TeacherCalendarUser["teacherMeetings"][0] & {
  key: string;
};
export type CalendarSection =
  | NonNullable<ParentScheduleCalendar_EnrollmentFragment["section"]>
  | CalendarMeeting["section"];
export type CalendarActivity = CalendarMeeting["section"]["activity"];
type CalendarEnrollment = ParentCalendarUser["activeEnrollments"][0];

export type MeetingListing = {
  meeting: CalendarMeeting;
  section: CalendarSection;
  activity: CalendarActivity;
  enrollments?: any[];
};

export type CalendarEvent = {
  meeting?: CalendarMeeting;
  id: string;
  title: string | null;
  section: CalendarSection;
  start: Date | null;
  end: Date | null;
  allDay: boolean;
  isClub?: boolean;
  enrollment?: CalendarEnrollment;
};

export type AgendaProps = {
  date?: Date;
  events: CalendarEvent[];
  t?: TFunction;
};

export type Slot = {
  start: Date;
};

export type FilterByTeacherStateProp = {
  filterByTeacher: string | null;
  setFilterByTeacher: (t: string | null) => void;
};

type CurrentUserForParentSchedule = NonNullable<
  ParentScheduleQueryQuery["currentUser"]
>;
type ActiveEnrollmentsForParentSchedule = NonNullable<
  CurrentUserForParentSchedule["activeEnrollments"]
>;
export type ActiveEnrollmentForParentSchedule = NonNullable<
  ActiveEnrollmentsForParentSchedule[number]
>;

/**
 * A fragment for activity that encapsulates the minimum amount of info you need
 * to query to render calendar views (e.g., teacher schedule, parent schedule)
 */
export const ActivityForCalendarFragment = gql`
  fragment ActivityForCalendarFragment on Activity {
    uid
    slug_id
    published_at
    title
    titleTranslated
    url
    path
    hasTeacherSchedule
    isClub
    isFlexSchedule
    isSelfPaced
    isOneTime
    duration_minutes
    duration_weeks
    weekly_meetings
    is_ongoing_weekly
    size_min
    size_max
    details {
      photo
    }
  }
`;
